/*Copyright (c) 2025 por Tecnologías de Información MALMUR y empresas afiliadas. Todos los derechos reservados.
Este software es información confidencial y propietaria de Copyright (c) 2025 por Tecnologías de Información MALMUR
 y sus afiliadas. ("Información Confidencial"). Usted no puede divulgar dicha Información Confidencial, 
 y solo puede usar dicha Información Confidencial de acuerdo con los términos del acuerdo de licencia que celebró con MALMUR.*/

/*Copyright (c) 2025 by Tecnologías de Información MALMUR and affiliated companies. All Rights Reserved.
This software is confidential and proprietary information of Copyright (c) 2025 by Tecnologías de Información 
MALMUR and its affiliates. ("Confidential Information"). You may not disclose such Confidential Information, 
and may only use such Confidential Information in accordance with the terms of the license agreement you entered 
into with MALMUR.*/



import React from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { RootReducer } from 'store/store';
import VideochatModal from 'components/views/VideochatModal';
import useVideochat from 'hooks/videochat.hook';

/**
 * Global videochat modal manager component.
 * 
 * Features:
 * - Monitors Redux videochat state for active calls
 * - Displays modal videochat interface when call is active
 * - Automatically hides on guest videochat pages (prevents duplicate UI)
 * - Integrates with Azure Communication Services
 * - Passes appointment context (patient/provider names)
 * - Handles call termination via endCall hook
 * 
 * This component is rendered globally in App.tsx and manages videochat
 * sessions throughout the application without requiring page-specific
 * videochat components.
 * 
 * @returns VideochatModal when active call exists, null otherwise
 */
const GlobalVideochat: React.FC = () => {
  const videochatState = useSelector((state: RootReducer) => state.videochat);
  const videochat = useVideochat();
  const location = useLocation();

  if (location.pathname.includes('/videochat/guest/')) {
    return null;
  }

  if (!videochatState.isOpen || !videochatState.appointmentId) {
    return null;
  }

  return (
    <VideochatModal
      appointmentId={videochatState.appointmentId}
      patientName={videochatState.patientName || ''}
      providerName={videochatState.providerName || ''}
      isOpen={videochatState.isOpen}
      onClose={videochat.endCall}
    />
  );
};

export default GlobalVideochat;
